import { render } from "./ClientiDataTable.vue?vue&type=template&id=7d893506&scoped=true"
import script from "./ClientiDataTable.vue?vue&type=script&lang=js"
export * from "./ClientiDataTable.vue?vue&type=script&lang=js"

import "./ClientiDataTable.vue?vue&type=style&index=0&id=7d893506&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d893506"]])

export default __exports__